import React, { useEffect } from "react";
import EventHeader from "../../container/event/header";
import Layout from "../../container/layout";
import { makeStyles } from "@material-ui/core/styles";
import { useParams, useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { loadFields } from "./action";
import { initPage } from "../home/action";

const useStyles = makeStyles((theme) => ({
  main: {
    lineHeight: "32px",
    fontSize: 18,
    fontFamily: "AP",
    color: "#585251",
    overflowWrap: "break-word",
    "& img": {
      maxWidth: "100% !important",
    },
    "& p": {
      margin: 0,
    },
    marginTop: 32,
    [theme.breakpoints.up("md")]: {
      marginTop: 16,
      padding: "32px 86px 32px 86px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
  },
  container: {
    marginTop: 0,
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
    [theme.breakpoints.up("xs")]: {
      marginTop: 32,
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: 0,
    },
  },
  banner: {
    width: "100%",
    maxWidth: 953,
    maxHeight: 250,
    margin: "0 auto",
    color: "#000000",
    textAlign: "center",
    "& img": {
      width: "100%",
      maxWidth: 953,
      maxHeight: 250,
      objectFit: "cover",
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: 58,
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: 113.51,
    },
  },
  titleSpace: {
    margin: 16,
  },
  textDesc: {
    color: "#585251",
    fontSize: 18,
    lineHeight: "32px",
    fontWeight: 400,
  },
  bg: {
    backgroundImage: "url('/photo/bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center bottom",
    [theme.breakpoints.up("xs")]: {
      padding: 16,
    },
    [theme.breakpoints.down("xs")]: {
      backgroundImage: "none",
    },
  },
}));

const Complete = () => {
  const classes = useStyles();
  const { id } = useParams();

  const navigate = useNavigate();

  const [state, setState] = React.useState({
    form: [],
    open: true,
    form_id: id,
    event: { banner_mobile: [], banner_desktop: [] },
  });

  useEffect(() => {
    initPage(state, setState, id, navigate);

    // loadFields(state, setState, state.form_id);
  }, []);

  return (
    <div className={classes.bg}>
      <div className={classes.banner}>
        <img
          src={
            isMobile
              ? `${process.env.REACT_APP_API_URL}/images/${
                  !!state.event.banner_inside_mobile
                    ? state.event.banner_inside_mobile[0]
                    : ""
                }`
              : `${process.env.REACT_APP_API_URL}/images/${
                  !!state.event.banner_inside_desktop
                    ? state.event.banner_inside_desktop[0]
                    : ""
                }`
          }
          width="100%"
          alt=""
        />
      </div>
      <div className={classes.container}>
        <Layout>
          <EventHeader
            title={state.event.assetName}
            description={state.event.des2}
            name="ท่านลงทะเบียนเรียบร้อยแล้ว"
          />
          <div
            className={classes.main}
            dangerouslySetInnerHTML={{
              __html: state.event.description_thanks,
            }}
          />
        </Layout>
      </div>
    </div>
  );
};

export default Complete;
